import React from "react";

import Stack, { StackProps } from "@rui/Stack";

const SettingContent = ({ sx, children, ...props }: StackProps) => {
  return (
    <Stack sx={{ pl: 3, py: 1, ...sx }} {...props}>
      {children}
    </Stack>
  );
};

export default SettingContent;
